import AppCardCustom from "@/components/AppCardCustom";
import PpcSbBudgetAllocationHeader from "@/components/PpcSbBudgetAllocationHeader";
import PpcSbBudgetAllocationItem from "@/components/PpcSbBudgetAllocationItem";
export default {
  name: "PpcSbBudgetAllocation",
  emits: ["item-update"],
  components: {
    AppCardCustom,
    PpcSbBudgetAllocationHeader,
    PpcSbBudgetAllocationItem
  },
  props: {
    items: {
      type: Array,
      default: () => []
    },
    currency: {
      type: String
    },
    selected_profile_id: {
      type: String
    },
    still_initializing: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      mode: "acos",
      search: "",
      weeklyBudgetTarget: null
    };
  },
  computed: {
    filteredItems() {
      return this.items.filter(item => item.name.toLowerCase().includes(this.search.toLowerCase())).sort((a, b) => {
        return b.sponsored_net_profit * 1 > a.sponsored_net_profit * 1 ? 1 : b.sponsored_net_profit * 1 < a.sponsored_net_profit * 1 ? -1 : 0;
      }).sort((a, b) => {
        return b.state.toLowerCase() < a.state.toLowerCase() ? 1 : b.state.toLowerCase() > a.state.toLowerCase() ? -1 : 0;
      });
    }
  },
  methods: {
    onItemUpdate(item) {
      this.$emit("item-update", item);
    },
    onWeeklyBudgetEdit(target) {
      this.weeklyBudgetTarget = target;
    }
  }
};